// @flow
import Symbol from 'core-js/es6/symbol';

import invariant from 'invariant';

import _ from 'lodash';
import ko from 'knockout';

const representations = Symbol('representations');

function represent (representationName = 'default') {
	const represent = this[representations][representationName];
	invariant(
		represent,
		`Representation named \`${representationName}\` is not attached to the observable`
	);
	return represent.call(this, this());
}

ko.extenders.repr = function representationExtender (target, options) {
	if (_.isFunction(options)) {
		options = { default: options };
	}

	target[representations] = target[representations] || {};
	_.extend(target[representations], options);

	target.repr = represent;
};

ko.extenders.inheritRepr = function inheritRepresentations (target, parent) {
	target.extend({
		repr: parent[representations],
	});
};
